import SafetyHookModelBase from '../_generated/modelBases/safety-hook-model-base';

export default class SafetyHookModel extends SafetyHookModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
